import React, {
  ComponentPropsWithRef,
  ComponentPropsWithoutRef,
  forwardRef,
  useContext,
} from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import SmoothCollapse from "react-smooth-collapse";

import styles from "./Accordion.scss";

import { AccordionItemContext } from "./AccordionItemContext";

export type AccordionPanelProps = {
  wrapperProps?: Partial<ComponentPropsWithoutRef<typeof SmoothCollapse>>;
  customClass?: string;
} & React.ComponentPropsWithRef<"div">;

const AccordionPanelWithRef = (
  props: AccordionPanelProps,
  ref: ComponentPropsWithRef<"div">["ref"]
) => {
  const { children, wrapperProps, customClass, ...restProps } = props;
  const accordionItem = useContext(AccordionItemContext);
  return (
    <SmoothCollapse
      expanded={accordionItem.isExpanded}
      heightTransition="0.4s ease"
      aria-hidden={!accordionItem.isExpanded}
      aria-labelledby={`accordion__heading-${accordionItem.id}`}
      id={`accordion__panel-${accordionItem.id}`}
      eagerRender
      {...wrapperProps}
    >
      <div ref={ref} className={cn(styles.panel, customClass)} {...restProps}>
        {children}
      </div>
    </SmoothCollapse>
  );
};

export const AccordionPanel = Object.assign(forwardRef(AccordionPanelWithRef), {
  propTypes: {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  },
  displayName: "Accordion.Item.Panel",
});

export default AccordionPanel;
